import React from 'react';

const GRADIENTS = {
  indigo:  'from-indigo-600 to-purple-600',
  purple:  'from-purple-600 to-pink-600',
  blue:    'from-blue-600 to-indigo-600',
  green:   'from-green-600 to-emerald-600',
  emerald: 'from-emerald-600 to-teal-600',
  amber:   'from-amber-500 to-orange-600',
  pink:    'from-pink-500 via-pink-600 to-rose-600',
  teal:    'from-teal-600 to-cyan-600',
  cyan:    'from-cyan-600 to-blue-600',
  rose:    'from-rose-500 to-pink-600',
};

export default function DashboardHero({
  icon = 'fa-tachometer-alt',
  title = 'Dashboard',
  subtitle,
  color = 'blue',
  children,
}) {
  const gradient = GRADIENTS[color] || GRADIENTS.blue;

  return (
    <div className={`bg-gradient-to-r ${gradient} text-white p-5 sm:p-6 rounded-lg shadow-md mb-6 relative overflow-hidden`}>
      {/* Decorative blobs */}
      <div className="absolute -top-10 -right-10 w-40 h-40 bg-white/10 rounded-full"></div>
      <div className="absolute -bottom-16 -left-10 w-56 h-56 bg-white/5 rounded-full"></div>

      <div className="relative z-10 flex items-center gap-4">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white/20 backdrop-blur flex items-center justify-center flex-shrink-0">
          <i className={`fas ${icon} text-xl sm:text-2xl`}></i>
        </div>

        <div className="min-w-0 flex-1">
          <h1 className="text-xl sm:text-2xl font-bold truncate">{title}</h1>
          {subtitle && (
            <p className="text-white/85 text-xs sm:text-sm mt-1">{subtitle}</p>
          )}
        </div>

        {children && <div className="flex-shrink-0">{children}</div>}
      </div>
    </div>
  );
}